import angular from 'angular';
import scenes from './scenes';
import addressLookupModal from './addressLookupModal';

export default angular
  .module('scenes.addressLookupModal', [scenes])
  .component('addressLookupModal', addressLookupModal).name;
